import React from "react";
import { Box } from "@mui/material";
import "./Card.css";

const Card = ({ title, subtitle, extraBtn, children }) => {
  return (
    <Box
      flex="1 1 min(48%, 400px)"
      className="card"
      bgcolor="white"
      boxShadow="0 0 5px rgba(6, 6, 6, 0.1)"
      m={2}
    >
      <div className="card-header">
        <div className="card-title-container">
          <span className="card-title">{title}</span>
          <span className="card-subtitle">{subtitle}</span>
        </div>

        {extraBtn && <div className="card-btn-container">{extraBtn}</div>}
      </div>
      {subtitle && <div className="card-subtitle"> </div>}


      <div className="card-content">{children}</div>

      </Box>
  );
};

export default Card;
